import React from 'react'

// import { ReactComponent as FirstBonusIcon } from 'shared/img/AAABBB/promotions/firstBonus.svg'
// import { ReactComponent as FirstBonusESIcon } from 'shared/img/AAABBB/promotions/firstBonusES.svg'
// import { ReactComponent as FirstBonusPTIcon } from 'shared/img/AAABBB/promotions/firstBonusPT.svg'
// import { ReactComponent as FreeSpinsIcon } from 'shared/img/AAABBB/promotions/freeSpins.svg'
// import { ReactComponent as FreeSpinsESIcon } from 'shared/img/AAABBB/promotions/freeSpinsES.svg'
// import { ReactComponent as FreeSpinsPTIcon } from 'shared/img/AAABBB/promotions/freeSpinsPT.svg'
import LogoImg from 'shared/img/promotionHeader.png'

import { getCurrencySymbol } from 'shared/constants/currencies/getCurrencySymbol'
import { languages, languagesType } from 'shared/locale'
import { localeBonusesType } from 'shared/locale/en-US'
import { AvailablePrmotionTabs, IGetUserPromotionsFilters } from 'shared/models/BonusSystem'
import { BonusName, BonusPromotionStatus, IUserPromotion } from 'shared/models/Promotion'

import { BonusTimer } from '../BonusTimer/Timer'
import { getBonusCardFirstDepositInfo, getBonusCardFreeSpinsInfo } from './bonusCardInfo'

export const getBonusInfo = ({
  promotion,
  isMobile,
  locale,
}: {
  promotion: IUserPromotion
  isMobile: boolean
  locale: localeBonusesType
}) => {
  const currencySymbol = getCurrencySymbol(promotion.promotionGrandAmountCurrency)

  switch (promotion.name) {
    case BonusName.firstDepositFreeSpins:
    case BonusName.everyDepositFreeSpins:
    case BonusName.register:
      return {
        img: {
          [languages.EN]: LogoImg,
          [languages.PT]: LogoImg,
          [languages.ES]: LogoImg,
        },
        front: {
          title: `${locale.freeSpins}`,
          value: `${promotion.freeSpinsCount}`,
          wonBonusTitle: `${locale.wonBonus}`,
          wonBonusContent: `${promotion.promotionGrandAmount} ${currencySymbol}`,
          firstColumnName: `${locale.rollOver}`,
          secondColumnName: `${locale.conquest}`,
          needToWinBackText: `${locale.metaRollOver}`,
        },
        back: {
          name: `${locale.freeSpins}`,
          text: `${locale.freeSpinBackCardInfo}`.replaceAll('{freespinCount}', `${promotion.freeSpinsGrantCount}`),
          // eslint-disable-next-line react/no-danger
          dangerousHtml: (lang: languagesType) => (
            <div
              dangerouslySetInnerHTML={getBonusCardFreeSpinsInfo(
                lang,
                promotion.freeSpinsGrantCount,
                promotion.name,
                promotion.wagerCoefficient,
              )}
            />
          ),
        },
      }
    case BonusName.firstDepositBonus:
    case BonusName.everyDepositBonus:
      return {
        img: {
          [languages.EN]: LogoImg,
          [languages.PT]: LogoImg,
          [languages.ES]: LogoImg,
        },
        front: {
          title: `${locale.bonus}`,
          value: `${promotion.promotionGrandAmount} ${currencySymbol}`,
          wonBonusTitle: `${locale.balanceAchieved}`,
          wonBonusContent: `${promotion.promotionGrandAmount} ${currencySymbol}`,
          firstColumnName: `${locale.target}`,
          secondColumnName: `${locale.targetAchieved}`,
          needToWinBackText: `${locale.needToWinBack}`,
        },
        back: {
          name: `${locale.bonus}`,
          ...(promotion.name === BonusName.everyDepositBonus ? { heading: `${locale.awardsFestival}` } : {}),
          text: `${locale.bonusBackCardInfo}`,
          dangerousHtml: (lang: languagesType) => (
            <div
              dangerouslySetInnerHTML={getBonusCardFirstDepositInfo(lang, promotion.depositCoefficient, promotion.name)}
            />
          ),
        },
      }
    default:
      return {
        img: {
          [languages.EN]: LogoImg,
          [languages.PT]: LogoImg,
          [languages.ES]: LogoImg,
        },
        front: {
          title: `${locale.bonus}`,
          value: `${promotion.promotionGrandAmount} ${currencySymbol}`,
          wonBonusTitle: `${locale.balanceAchieved}`,
          wonBonusContent: `${promotion.promotionGrandAmount} ${currencySymbol}`,
          firstColumnName: `${locale.wagerCoef}`,
          secondColumnName: `${locale.wagerComplete}`,
          needToWinBackText: `${locale.needToWinBack}`,
        },
        back: {
          name: `${locale.bonus}`,
          text: `${locale.bonusBackCardInfo}`,
          dangerousHtml: (lang: languagesType) => (
            <div
              dangerouslySetInnerHTML={getBonusCardFirstDepositInfo(lang, promotion.depositCoefficient, promotion.name)}
            />
          ),
        },
      }
  }
}

export const getBonusValidateTerm = ({
  promotion,
  locale,
  payloadFilters,
}: {
  promotion: IUserPromotion
  locale: localeBonusesType
  payloadFilters: IGetUserPromotionsFilters
}) => {
  switch (promotion.status) {
    case BonusPromotionStatus.active:
    case BonusPromotionStatus.completed:
    case BonusPromotionStatus.available:
    case BonusPromotionStatus.available_completed:
      return <BonusTimer payloadFilters={payloadFilters} countDownDate={promotion.expirationDate} />
    default:
      return locale[promotion.status]
  }
}
